import React from 'react'

export const SvgSprite: React.FC = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }} aria-hidden="true">
    <symbol viewBox="0 0 24 24" id="svg-arrow" preserveAspectRatio="none">
      <path fill="currentColor" d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z" />
    </symbol>
    <symbol viewBox="0 0 20 20" id="svg-external" preserveAspectRatio="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H8.33333C8.79357 2.5 9.16667 2.8731 9.16667 3.33333C9.16667 3.79357 8.79357 4.16667 8.33333 4.16667H5C4.77899 4.16667 4.56702 4.25446 4.41074 4.41074C4.25446 4.56702 4.16667 4.77899 4.16667 5V15C4.16667 15.221 4.25446 15.433 4.41074 15.5893C4.56702 15.7455 4.77899 15.8333 5 15.8333H15C15.221 15.8333 15.433 15.7455 15.5893 15.5893C15.7455 15.433 15.8333 15.221 15.8333 15V11.6667C15.8333 11.2064 16.2064 10.8333 16.6667 10.8333C17.1269 10.8333 17.5 11.2064 17.5 11.6667V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223ZM12.5 4.16667C12.0398 4.16667 11.6667 3.79357 11.6667 3.33333C11.6667 2.8731 12.0398 2.5 12.5 2.5H16.6667C17.1269 2.5 17.5 2.8731 17.5 3.33333V7.5C17.5 7.96024 17.1269 8.33333 16.6667 8.33333C16.2064 8.33333 15.8333 7.96024 15.8333 7.5V5.34518L10.5893 10.5893C10.2638 10.9147 9.73618 10.9147 9.41074 10.5893C9.08531 10.2638 9.08531 9.73618 9.41074 9.41074L14.6548 4.16667H12.5Z"
        fill="currentColor"
      />
    </symbol>
  </svg>
)

type IconProps = {
  name: 'arrow' | 'external'
  viewBox: string
  className: string
}

export const Icon: React.FC<IconProps> = ({ name, viewBox, className }) => (
  <svg viewBox={viewBox} className={className}>
    <use xlinkHref={`#svg-${name}`} />
  </svg>
)
